import React, { Component } from "react";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { IconButton, Slide } from "@material-ui/core";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Attachment from "../../models/Attachment";
import Slider from "react-slick";
import { Document, Page } from "react-pdf";
import attachmentsRequestHandler from "../../api/attachmentsRemote";
import { isImg, isDoc } from "../../utils/attachment";
import documentStyles from "./documents.module.css";
import { headers } from "../../api/headers";
import CloseIcon from '@material-ui/icons/Close';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';


const NextArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
    aria-label="Next"
    onClick={ onClick }
    className={ newClass }
  >
    <ArrowRightIcon className={ documentStyles.right_arrow }
      color="primary"
    />
  </IconButton>
  );
}

const PrevArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
    aria-label="Prev"
    onClick={ onClick }
    className={ newClass }
  >
    <ArrowLeftIcon className={ documentStyles.left_arrow }
      color="primary"
    />
  </IconButton>
  );
}

const materialStyles = (theme: Theme) =>
  createStyles({
    close: {
      position: 'absolute',
      right: '1%',
      zIndex: 12,
      top: '3%'
    },
    left_arrow: {
      position: 'fixed',
      top: '50%',
      left: '0',
      zIndex: 12,
      filter:'invert(100%) sepia(6%) saturate(0%) hue-rotate(70deg) brightness(108%) contrast(108%)',
    },
    right_arrow: {
      position: 'fixed',
      top: '50%',
      right: '1%',
      zIndex: 12,
      filter:'invert(100%) sepia(6%) saturate(0%) hue-rotate(70deg) brightness(108%) contrast(108%)',
    }
  });

interface DocumentsProps {
  classes: any;
  closeAttachments: (event: any) => void;
  attachmentsList: Array<Attachment>;
  checked: boolean;
};

interface DocumentsState {
  numPages: any;
};

class Documents extends Component<DocumentsProps, DocumentsState> {
  state: DocumentsState = {
    numPages: {}
  };

  openLink = (link: string): void => {
    window.open(link);
  }

  settings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    nextArrow: <NextArrow newClass={ this.props.classes.right_arrow }/>,
    prevArrow: <PrevArrow newClass={ this.props.classes.left_arrow }/>
  };

  onDocumentLoadSuccess = (num: any, index: number): void => {
    const numPages = this.state.numPages;
    numPages[`pdf_${index}`] = num._pdfInfo.numPages;
    this.setState({ numPages });
  }

  render() {
    return (
      <div>
        <div className={ documentStyles.overlay }></div>
        <Slide direction="down" in={ this.props.checked } timeout={600} mountOnEnter unmountOnExit>
          <div className={`${ documentStyles.screeningDocContainer } ${ documentStyles.docContainer }`}>
            <IconButton
              aria-label="Document"
              onClick={ this.props.closeAttachments }
              className={ this.props.classes.close }
            >
              <CloseIcon className={ documentStyles.closeIcon }
                color="primary"
              />
            </IconButton>
            <div className={ documentStyles.attachmentsWrapper }>

              <div className={ documentStyles.attachmentChild }>
                <Slider {...this.settings}>
                  {this.props.attachmentsList.map((item: Attachment, i: number) => {
                    const itemLink: string = attachmentsRequestHandler.constructAttachmentUrl(
                      item.attachment_key
                    );
                    return (
                      <div key={i}>

                        {isImg(item.uploaded_filename) && (
                          <img
                            src={ itemLink }
                            alt={ item.uploaded_filename }
                            className={ documentStyles.image }
                          />
                        )}
                        {isDoc(item.uploaded_filename) && (
                          <Document
                            file={ itemLink }
                            onItemClick={() => {
                              this.openLink(itemLink);
                            }}
                            options={{
                              httpHeaders: headers,
                              withCredentials: true
                            }}
                            onLoadSuccess={(page) => this.onDocumentLoadSuccess(page, i)}
                          > {
                              Array.from(
                                new Array(this.state.numPages[`pdf_${i}`]),
                                (el, index) => (
                                  <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                  />
                                )
                              )
                            }
                          </Document>
                        )}
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </Slide>
      </div>
      
    );
  }

}

export default withStyles(materialStyles)(Documents);
